import { globalEventBus } from '@fiverr-private/futile';
import { LOGGER } from '../helpers/eventName';
import { LEVELS } from '../helpers/logLevels';

/**
 * force argument
 * @type {boolean}
 */
const force = true;

const logger = LEVELS.reduce(
    (accumulator, level) => Object.assign(
        accumulator,
        {
            [level]: (entity, enrichments = {}) => globalEventBus.deferred(
                LOGGER,
                { entity, enrichments, level }
            )
        }
    ),
    {}
);

Object.defineProperty(
    logger,
    'force',
    {
        value: LEVELS.reduce(
            (accumulator, level) => Object.assign(
                accumulator,
                {
                    [level]: (entity, enrichments = {}) => globalEventBus.deferred(
                        LOGGER,
                        { entity, enrichments, level, force }
                    )
                }
            ),
            {}
        )
    }
);

export default logger;
